export default "__VITE_ASSET___rilYDmf__"